import { Chip, Tooltip } from '@mui/material'
import { describeNotificationStatus } from '@/services/notificationStatuses'

type Props = {
  status: string
  lastError?: string | null
  /** A smaller chip for a grid cell that shows several. */
  dense?: boolean
}

const NotificationStatusChip = ({ status, lastError, dense }: Props) => {
  const { label, color } = describeNotificationStatus(status)
  const chip = (
    <Chip
      size="small"
      label={label}
      color={color}
      sx={
        dense
          ? { height: 20, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }
          : undefined
      }
    />
  )
  if (!lastError) return chip
  return (
    <Tooltip title={lastError} aria-label={lastError}>
      {chip}
    </Tooltip>
  )
}

export default NotificationStatusChip
